var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M603.691-333.847 561.539-376l104-104-104-104 42.152-42.153 104 104 104-104L853.844-584l-104 104 104 104-42.153 42.153-104-104-104 104Zm-457.535-46.154v-199.998h148.46l171.537-171.536v543.07L294.616-380.001h-148.46Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeX);
export default __webpack_public_path__ + "static/media/volume-x.4721095b7897013dc0613e6c407b8cf7.svg";
export { ForwardRef as ReactComponent };